class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
    if (this.header) this.header.preventHide = false;
    this.mouseX = 0;
    this.mouseY = 0;
    this.floatingX = 0;
    this.floatingY = 0;
    this.raf = null;
    this.mediaQuery = window.matchMedia(
      "(pointer: fine) and (min-width: 990px)"
    );
    this.dynamicEnabled = false;
    this.close = this.close.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.animateFollow = this.animateFollow.bind(this);
    this.onMediaChange = this.onMediaChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }
  connectedCallback() {
    this.addEventListener("click", this.handleClick);
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.setHeaderCartIconAccessibility();
  }
  disconnectedCallback() {
    this._disableDynamic();
    this.mediaQuery.removeEventListener("change", this.onMediaChange);
  }
  handleClick(event) {
    if (event.target.id === "CartDrawer-Overlay") {
      this.close();
    }
  }
  setHeaderCartIconAccessibility() {
    const cartLinks = document.querySelectorAll(
      "#cart-icon-bubble, #cart-icon-bubble-burger"
    );
    if (!cartLinks) return;
    cartLinks.forEach((cartLink) => {
      cartLink.setAttribute("role", "button");
      cartLink.setAttribute("aria-haspopup", "dialog");
      cartLink.addEventListener("click", (event) => {
        event.preventDefault();
        if (!this.classList.contains("active")) {
          this.open(cartLink, event);
        } else {
          this.close();
        }
      });
    });
  }
  open(triggeredBy, event) {
    if (this.header) {
      this.header.preventHide = true;
      this.header.preventReveal = true;
    }
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const search = document.querySelector("header-search.header__search");
    if (search) search.close(null, true);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) {
      this.setSummaryAccessibility(cartDrawerNote);
    }
    this.classList.add("active");
    this.closeButton = this.querySelector(".cart-drawer__close-btn");
    this.mediaQuery.addEventListener("change", this.onMediaChange);
    this.onMediaChange(this.mediaQuery);
    if (event && this.dynamicEnabled) {
      this.instantPositionCloseButton(event);
    }
    this.addEventListener(
      "transitionend",
      () => {
        if (document.documentElement.classList.contains("herbz-autocart-open")) return;
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
    document.body.classList.add("overflow-hidden-cart-drawer");
  }
  close() {
    this.classList.remove("active");
    this._disableDynamic();
    this.mediaQuery.removeEventListener("change", this.onMediaChange);
    if (this.activeElement) {
      this.activeElement.focus();
    }
    document.body.classList.remove("overflow-hidden-cart-drawer");
    if (this.header) {
      this.header.preventHide = false;
      this.header.preventReveal = false;
    }
  }
  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");
    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }
    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });
    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }
  renderContents(parsedState, evt) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });
    setTimeout(() => {
      this.open(null, evt);
    });
  }
  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
      {
        id: "cart-icon-bubble-burger",
      },
    ];
  }
  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
  instantPositionCloseButton(event) {
    if (!this.closeButton) return;
    const offsetX = 32,
      offsetY = 32;
    let clientX, clientY;
    if (event instanceof MouseEvent && typeof event.clientX === "number") {
      clientX = event.clientX;
      clientY = event.clientY;
    } else if (event && event.submitter) {
      const rect = event.submitter.getBoundingClientRect();
      clientX = rect.left + rect.width / 2;
      clientY = rect.top + rect.height / 2;
    } else {
      clientX = window.innerWidth / 2;
      clientY = window.innerHeight / 2;
    }
    this.mouseX = clientX - offsetX;
    this.mouseY = clientY - offsetY;
    this.floatingX = this.mouseX;
    this.floatingY = this.mouseY;
    Object.assign(this.closeButton.style, {
      position: "fixed",
      zIndex: "9999",
      left: `${this.floatingX}px`,
      top: `${this.floatingY}px`,
    });
    this.addEventListener(
      "transitionend",
      () => {
        const drawerInner = this.querySelector(".drawer__inner");
        if (drawerInner) {
          const rect = drawerInner.getBoundingClientRect();
          const isOverDrawer =
            clientX >= rect.left &&
            clientX <= rect.right &&
            clientY >= rect.top &&
            clientY <= rect.bottom;
          if (isOverDrawer) {
            this.classList.remove("cursor-active");
          } else {
            this.classList.add("cursor-active");
          }
        }
      },
      { once: true }
    );
  }
  onMouseMove(event) {
    if (!this.closeButton) return;
    const offsetX = 32,
      offsetY = 32;
    this.mouseX = event.clientX - offsetX;
    this.mouseY = event.clientY - offsetY;
    if (!event.target.closest(".drawer__inner")) {
      this.classList.add("cursor-active");
    } else {
      this.classList.remove("cursor-active");
    }
  }
  animateFollow() {
    if (!this.closeButton) return;
    const ease = 0.25;
    this.floatingX += (this.mouseX - this.floatingX) * ease;
    this.floatingY += (this.mouseY - this.floatingY) * ease;
    Object.assign(this.closeButton.style, {
      position: "fixed",
      zIndex: "3",
      left: `${this.floatingX}px`,
      top: `${this.floatingY}px`,
    });
    this.raf = requestAnimationFrame(this.animateFollow);
  }
  onMediaChange(e) {
    if (e.matches && !this.dynamicEnabled) {
      this._enableDynamic();
    } else if (!e.matches && this.dynamicEnabled) {
      this._disableDynamic();
    }
  }
  _enableDynamic() {
    this.dynamicEnabled = true;
    document.addEventListener("mousemove", this.onMouseMove);
    this.raf = requestAnimationFrame(this.animateFollow);
  }
  _disableDynamic() {
    if (!this.dynamicEnabled) return;
    this.classList.remove("cursor-active");
    document.removeEventListener("mousemove", this.onMouseMove);
    cancelAnimationFrame(this.raf);
    this.dynamicEnabled = false;
  }
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-icon-bubble-burger",
        section: "cart-icon-bubble-burger",
        selector: ".shopify-section",
      },
    ];
  }
}
customElements.define("cart-drawer-items", CartDrawerItems);
